import { secondsToTimeString } from '@/helpers/dateHelper';
import {
  UNKNOWN_LEAVE_TYPE_SURFACE_COLOR,
  UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR
} from '@/services/availability/availability.types';
import { PendingAvailabilityException } from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { cellStyling } from './teamMemberCalendar.const';
import { useLeaveTypeCalendarDisplay } from './useLeaveTypeCalendarDisplay';
interface TeamMemberPendingAvailabilityRequestCellProps {
  exception: PendingAvailabilityException;
}
export const TeamMemberPendingAvailabilityRequestCell: FC<TeamMemberPendingAvailabilityRequestCellProps> = ({
  exception
}) => {
  const { label, hasLeaveType, colour } = useLeaveTypeCalendarDisplay(exception.leaveType?.id);
  const wrapperColor = hasLeaveType ? (colour ? `${colour}80` : UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR) : undefined;
  const surfaceColor = hasLeaveType ? (colour ?? UNKNOWN_LEAVE_TYPE_SURFACE_COLOR) : undefined;
  return (
    <div
      className="flex items-center justify-center h-full px-3 py-2"
      style={wrapperColor ? { backgroundColor: wrapperColor } : undefined}
    >
      <div
        className={twMerge(
          'flex-col items-center justify-center rounded-md border',
          hasLeaveType ? 'border-solid' : 'bg-gray-200 border-dotted border-gray-500',
          cellStyling,
          'text-xs'
        )}
        style={surfaceColor ? { backgroundColor: surfaceColor } : undefined}
      >
        <p>{strings.common.requested.toUpperCase()}:</p>
        {hasLeaveType ? (
          <p>{label}</p>
        ) : (
          <p>
            {secondsToTimeString(exception.start!)} - {secondsToTimeString(exception.end!)}
          </p>
        )}
      </div>
    </div>
  );
};
